import { i18n as _i18n } from "@lingui/core";
import { useLingui } from '@lingui/react';
import { BannerReturnCustomer, CarleadLayout } from '@wkda/carlead-creation-components';
import { Helmet } from 'react-helmet';
import CarleadCollapseButtonFaq from '../../../../components/carlead/CarleadCollapseButton';
import { CarleadHowItWorks } from '../../../../components/shared/HowItWorks';
import CarleadTextButton from '../../../../components/carlead/CarleadTextButton';
import { CarleadTopBlueCar } from '../../../../components/carlead/CarleadTopBlueCar';
import CarleadWhyChoose from '../../../../components/carlead/CarleadWhyChoose';
import { getHappyCustomerSliderCarleadContent } from '../../../../components/carlead/HappyCustomerSlider/happyCustomerSliderContent';
import { getImageContent } from '../../../../components/shared/ImageContent/content';
import { HappyCustomerSlider } from '../../../../components/carlead/HappyCustomerSlider';
import ImageContent from '../../../../components/shared/ImageContent';
import TrustPilot from '../../../../components/appointment/TrustPilot';
import { CarleadCrossPromoBannerAH } from '../../../../components/carlead/CarleadCrossPromoBannerAH';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const CarleadTopBlueCarHCSliderMap = ({
  form,
  happyCustomerSettingsOverrides = '',
  className = '',
  howItWorksShowCta = false,
  withLayout = true,
  showTrustPilot = false
}) => {
  const mapContent = getImageContent().mapContent;
  const happyCustomerSliderSlimContent = getHappyCustomerSliderCarleadContent('happyCustomersSlim');
  const {
    i18n
  } = useLingui();
  const sections = /*#__PURE__*/_jsxs(_Fragment, {
    children: [showTrustPilot && /*#__PURE__*/_jsx("div", {
      className: "box gap white",
      children: /*#__PURE__*/_jsxs("section", {
        className: "trust-box",
        children: [/*#__PURE__*/_jsx("div", {
          className: "d-none d-lg-block",
          children: /*#__PURE__*/_jsx(TrustPilot, {
            type: "lead",
            screen: "desktop"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "d-block d-lg-none",
          children: /*#__PURE__*/_jsx(TrustPilot, {
            type: "lead",
            screen: "mobile"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "box gap white",
      children: /*#__PURE__*/_jsx("div", {
        className: "container",
        children: /*#__PURE__*/_jsx(HappyCustomerSlider, {
          content: happyCustomerSliderSlimContent,
          overrides: happyCustomerSettingsOverrides
        })
      })
    }), /*#__PURE__*/_jsx(CarleadHowItWorks, {
      showCTA: howItWorksShowCta
    }), /*#__PURE__*/_jsx("div", {
      className: "box map-box white",
      "data-category": "Map",
      children: /*#__PURE__*/_jsx("div", {
        className: "container",
        children: /*#__PURE__*/_jsx(ImageContent, {
          className: mapContent.className,
          image: mapContent.image,
          imageColumn: mapContent.imageColumn,
          contentColumn: mapContent.contentColumn,
          cta: mapContent.cta,
          contentTitle: mapContent.contentTitle,
          contentSubtitle: mapContent.contentSubtitle
        })
      })
    }), /*#__PURE__*/_jsx(CarleadWhyChoose, {}), /*#__PURE__*/_jsx(CarleadCollapseButtonFaq, {}), /*#__PURE__*/_jsx(CarleadTextButton, {
      text: _i18n._(
      /*i18n*/
      {
        id: 'carlead.textButton.text'
      })
    }), /*#__PURE__*/_jsx(CarleadCrossPromoBannerAH, {})]
  });
  if (!withLayout) {
    return sections;
  }
  return /*#__PURE__*/_jsxs(CarleadLayout, {
    customBanner: BannerReturnCustomer,
    containerClassName: `carlead-redesign carlead-redesign-blue ${className}`,
    modernLayout: true,
    children: [/*#__PURE__*/_jsx(Helmet, {
      children: /*#__PURE__*/_jsx("title", {
        children: i18n._('carlead.pageTitle')
      })
    }), /*#__PURE__*/_jsxs("div", {
      "data-category": "Lead Page",
      children: [/*#__PURE__*/_jsx("div", {
        className: "box blue top-blue-car-box",
        children: /*#__PURE__*/_jsx(CarleadTopBlueCar, {})
      }), form, sections]
    })]
  });
};
export default CarleadTopBlueCarHCSliderMap;